import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footer from "../layouts/Footerthree";
import Content from "../sections/ThinkToKnow/SellUs";
import Download from "../layouts/App";
import { useTranslation } from "react-i18next";

const SellForm = () => {
  const {t}=useTranslation();

  return (
    <Fragment>
      <Helmet>
        <title>
          Buy Home For Less | Sell Your Property to Us
        </title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb
        breadcrumb={{ pagename:  t("sell_property") }}
      />

      <Content />
      <Download />
      <Footer />
    </Fragment>
  );
};

export default SellForm;
